import UsuarioTable from './UsuarioTable';

export default UsuarioTable;
